import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Heading, Primary } from "@cinch-labs/design-system";
import styles from "./cta.module.css";
import { EventNames, TrackingEventTypes, useAnalytics } from "@cinch-nx/shared-analytics";
export const Cta = ({ cta  })=>{
    const { title , body , ctaText  } = cta;
    const ctaCategory = "happy to travel to any cinch store?";
    const { trackEvent  } = useAnalytics();
    const allStoresPath = "used-cars?store=all-stores";
    const handleClick = ()=>{
        trackEvent({
            eventName: `cinch stores hub - ${ctaCategory}`,
            type: TrackingEventTypes.ADOBE,
            data: {
                action: "select",
                event: {
                    name: EventNames.click,
                    category: ctaCategory,
                    label: "search all cinch store cars"
                }
            }
        });
        window.open(allStoresPath, "_blank");
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.ctaWrapper,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.textWrapper,
                children: [
                    /*#__PURE__*/ _jsx(Heading, {
                        element: "h3",
                        children: title
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        children: body
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Primary, {
                href: allStoresPath,
                onClick: ()=>handleClick(),
                children: ctaText
            })
        ]
    });
};
